module.exports = __webpack_public_path__ + "img/icon_map_10_on_011.7cf310e3.png";